import { createReducer, on } from '@ngrx/store';
import * as CreateDestinationActions from '../actions/create-destination.actions';

export const createDestinationFeatureKey = 'createDestination';

export interface State {
  record: any;
  error: any;
  loaded: boolean;
  loading: boolean;
}

export const initialState: State = {
  record: null,
  error: null,
  loaded: false,
  loading: false,
};


export const reducer = createReducer(
  initialState,

  on(CreateDestinationActions.createDestination, () => ({
    record: null,
    error: null,
    loaded: false,
    loading: true,
  })),
  on(CreateDestinationActions.createDestinationSuccess, (state, action) => ({
    record: action.data,
    error: null,
    loaded: true,
    loading: false,
  })),
  on(CreateDestinationActions.createDestinationFailure, (state, action) => ({
    record: null,
    error: action.error,
    loaded: false,
    loading: false,
  })),
  on(CreateDestinationActions.clearCreateDestinationState, () => ({
    record: null,
    error: null,
    loaded: false,
    loading: false,
  })),
);

